/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Most_Popular_BadgeInputs */

const en_signup_most_popular_badge = /** @type {(inputs: Signup_Most_Popular_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most Popular`)
};

const fr_signup_most_popular_badge = /** @type {(inputs: Signup_Most_Popular_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le Plus Populaire`)
};

const de_signup_most_popular_badge = /** @type {(inputs: Signup_Most_Popular_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Am beliebtesten`)
};

const it_signup_most_popular_badge = /** @type {(inputs: Signup_Most_Popular_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I più popolari`)
};

const ru_signup_most_popular_badge = /** @type {(inputs: Signup_Most_Popular_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Самые популярные`)
};

const es_signup_most_popular_badge = /** @type {(inputs: Signup_Most_Popular_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más populares`)
};

const zh_cn2_signup_most_popular_badge = /** @type {(inputs: Signup_Most_Popular_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最受欢迎`)
};

const ja_signup_most_popular_badge = /** @type {(inputs: Signup_Most_Popular_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最も人気のある`)
};

const hi_signup_most_popular_badge = /** @type {(inputs: Signup_Most_Popular_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सबसे लोकप्रिय`)
};

const pt_pt2_signup_most_popular_badge = /** @type {(inputs: Signup_Most_Popular_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais populares`)
};

/**
* | output |
* | --- |
* | "Most Popular" |
*
* @param {Signup_Most_Popular_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_most_popular_badge = /** @type {((inputs?: Signup_Most_Popular_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Most_Popular_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_most_popular_badge(inputs)
	if (locale === "de") return de_signup_most_popular_badge(inputs)
	if (locale === "it") return it_signup_most_popular_badge(inputs)
	if (locale === "ru") return ru_signup_most_popular_badge(inputs)
	if (locale === "es") return es_signup_most_popular_badge(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_most_popular_badge(inputs)
	if (locale === "ja") return ja_signup_most_popular_badge(inputs)
	if (locale === "hi") return hi_signup_most_popular_badge(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_most_popular_badge(inputs)
	return en_signup_most_popular_badge(inputs)
});